import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const ContactService = {
  getList: async () => {
    const response = await apiService.get("/branchoffices",{
      page:1,
      pageSize:20
    });
    console.log("called")
    return response.data;
  },

  getById: async (id) => {
    const response = await apiService.get(`/branchoffices/${id}`);
    return response.data;
  },
    
}

export default ContactService
